import type { ImageInterface } from '@/shared/models/ImageInterface'

export function createImageInterface (src = ''): ImageInterface {
  return { src, file: undefined as unknown as File }
}

export function loadImageInterface (file: File): ImageInterface {
  return { src: URL.createObjectURL(file), file }
}

function readAsDataURL (file: File | Blob): Promise<string | ArrayBuffer | null> {
  return new Promise((resolve, reject) => {
    const fr = new FileReader()
    fr.onerror = reject

    fr.onload = (): void => {
      resolve(fr.result)
    }
    fr.readAsDataURL(file)
  })
}

export async function toBase64 (img: File | Blob | null | undefined): Promise<string> {
  // Validação de tipo - verifica se é um File ou Blob válido
  if (!img || !(img instanceof File || img instanceof Blob)) {
    // Retorna string vazia silenciosamente para inputs inválidos
    return ''
  }

  try {
    const result = await readAsDataURL(img)
    const b64Encoded = result?.toString() ?? ''
    return b64Encoded
  } catch (error) {
    // Em caso de erro na leitura, retorna string vazia
    return ''
  }
}

export function toUrlNoCache (url?: string): string | undefined {
  /**
   * Ex: A imagem do produto é baseada no seu próprio ID, ou seja, ao trocar de imagem a URL permanece fixa.
   */
  if (!url) {
    return undefined
  }

  const separator = url.includes('?') ? '&' : '?'

  return `${url}${separator}q=${Date.now()}`
}
